export const SELF_BOOK_ROUTE = {
    CONTINUE: 'CONTINUE',
    SLOT_BOOKING: 'SLOT_BOOKING',
};
// wcs_id (workflow candidate step id) in the invite URL marks a self-booking candidate.
export const parseWcsId = (value) => {
    if (!value || !/^\d+$/.test(value))
        return undefined;
    const id = Number(value);
    return id > 0 ? id : undefined;
};
// BE already scopes drive_occurrence_guests to the requesting candidate.
export const getStepGuests = (occurrences) => occurrences.flatMap((occurrence) => occurrence.drive_occurrence_guests ?? []);
// Same "booked" rule as /drive/slot-booking (DriveSchedulingLogic.ts).
export const findBookedGuest = (guests) => guests.find((guest) => Boolean(guest.from && guest.to));
export const resolveSelfBookRoute = ({ wcsId, occurrences }) => {
    if (!wcsId || !occurrences)
        return SELF_BOOK_ROUTE.CONTINUE;
    return findBookedGuest(getStepGuests(occurrences)) ? SELF_BOOK_ROUTE.CONTINUE : SELF_BOOK_ROUTE.SLOT_BOOKING;
};
const isValidDate = (value) => !Number.isNaN(Date.parse(value));
// Each occurrence on canx_get_step_details is one bookable slot (same shape as sch_get_drive_slots).
// An occurrence with an unparseable date can be neither shown nor ordered, so it is dropped.
export const getOccurrenceSlots = (occurrences) => occurrences
    .filter(({ start_date, end_date }) => isValidDate(start_date) && isValidDate(end_date))
    .map(({ id, drive_schedule_id, start_date, end_date }) => ({
    drive_occurrence_id: id,
    drive_schedule_id,
    from: start_date,
    to: end_date,
}))
    .sort((a, b) => Date.parse(a.from) - Date.parse(b.from));
